// frontend/src/pages/teacher/GroupManagementPage.js (نسخه اصلاح شده)

import React, { useState, useEffect, useCallback } from 'react';
// ✅ ایمپورت Link
import { useParams, Link, useNavigate } from 'react-router-dom';
import axiosInstance from '../../modules/api';
import { FaUsers, FaPlus, FaSpinner, FaArrowLeft, FaEdit, FaTrash, FaUserPlus } from 'react-icons/fa';

// ... (کامپوننت StudentList و ... بدون تغییر) ...

const GroupManagementPage = () => {
    const { courseId } = useParams();
    const navigate = useNavigate();
    // ... (تمام state ها و توابع fetchGroups, handleCreateGroup, handleDeleteGroup) ...
    const [groups, setGroups] = useState([]);
    const [courseTitle, setCourseTitle] = useState('...');
    const [newGroupName, setNewGroupName] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [formError, setFormError] = useState(null);

    const fetchGroups = useCallback(async () => {
        setLoading(true);
        try {
            try {
                const courseRes = await axiosInstance.get(`/core/teacher/courses/${courseId}/`);
                setCourseTitle(courseRes.data.title);
            } catch (courseErr) {
                console.warn("Could not fetch course title", courseErr);
                setCourseTitle("دوره نامشخص");
            }
            const response = await axiosInstance.get(`/core/teacher/groups/`, {
                params: { course_id: courseId }
            });
            setGroups(response.data);
        } catch (err) {
            console.error("Error fetching groups:", err);
            setError(err.response?.data?.detail || "خطا در بارگذاری گروه‌ها.");
        } finally {
            setLoading(false);
        }
    }, [courseId]);

    useEffect(() => {
        fetchGroups();
    }, [fetchGroups]);

    const handleCreateGroup = async (e) => {
        e.preventDefault();
        if (!newGroupName.trim()) {
            setFormError("نام گروه نمی‌تواند خالی باشد.");
            return;
        }
        setFormLoading(true);
        setFormError(null);
        try {
            await axiosInstance.post('/core/teacher/groups/', {
                name: newGroupName,
                course: courseId
            });
            setNewGroupName("");
            await fetchGroups();
        } catch (err) {
            console.error("Error creating group:", err);
            setFormError(err.response?.data?.name || err.response?.data?.detail || "خطا در ساخت گروه.");
        } finally {
            setFormLoading(false);
        }
    };
    
    const handleDeleteGroup = async (groupId, groupName) => {
        if (!window.confirm(`آیا از حذف گروه "${groupName}" مطمئن هستید؟`)) return;
        try {
            await axiosInstance.delete(`/core/teacher/groups/${groupId}/`);
            await fetchGroups();
        } catch (err) {
             alert(err.response?.data?.detail || "خطا در حذف گروه.");
        }
    };


    const renderGroupList = () => {
        if (loading) return <div className="text-center p-5"><FaSpinner className="spinner" /></div>;
        if (error) return <div className="alert alert-danger">{error}</div>;
        if (groups.length === 0) return <p className="text-center text-gray-400 p-4">هنوز هیچ گروهی برای این دوره ساخته نشده است.</p>;

        return (
            <table className="data-table">
                <thead>
                    <tr>
                        <th>نام گروه</th>
                        <th>تعداد اعضا</th>
                        <th>تاریخ ایجاد</th>
                        <th>عملیات</th>
                    </tr>
                </thead>
                <tbody>
                    {groups.map(group => (
                        <tr key={group.id}>
                            <td>
                                {/* ✅✅✅ نام گروه اکنون یک لینک به اتاق چت است ✅✅✅ */}
                                <Link 
                                    to={`/chat/group/${group.id}`} 
                                    style={{color: 'var(--accent-cyan)', fontWeight: 'bold'}}
                                    title="ورود به اتاق گفتگو"
                                >
                                    {group.name}
                                </Link>
                            </td>
                            <td>{group.member_count} نفر</td>
                            <td>{new Date(group.created_at).toLocaleDateString('fa-IR')}</td>
                            <td>
                                <div className="action-buttons">
                                    <button 
                                        className="action-btn btn-view" 
                                        title="مدیریت اعضا"
                                        onClick={() => navigate(`/teacher/groups/${group.id}/members`)}
                                    >
                                        <FaUserPlus />
                                    </button>
                                    <button className="action-btn btn-edit" title="تغییر نام"><FaEdit /></button>
                                    <button 
                                        className="action-btn btn-delete" 
                                        title="حذف گروه"
                                        onClick={() => handleDeleteGroup(group.id, group.name)}
                                    >
                                        <FaTrash />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (
        <div className="page-container" style={{maxWidth: '1000px'}}>
            <Link to="/teacher/courses" className="button button-secondary mb-6 inline-flex items-center">
                <FaArrowLeft className="ml-2" /> بازگشت به لیست دوره‌ها
            </Link>

            <div className="page-header" style={{paddingBottom: '10px', marginBottom: '20px'}}>
                <div>
                    <h1 className="flex items-center gap-3"><FaUsers /> مدیریت گروه‌ها</h1>
                    <p>دوره: {courseTitle}</p>
                </div>
            </div>

            {/* فرم ساخت گروه جدید */}
            <div className="form-card mb-6" style={{backgroundColor: '#1f2937'}}>
                <form className="group-creation-form" onSubmit={handleCreateGroup}>
                    <input
                        type="text"
                        value={newGroupName}
                        onChange={(e) => setNewGroupName(e.target.value)}
                        placeholder="نام گروه جدید (مثلا: گروه الف)"
                        disabled={formLoading}
                        required
                    />
                    <button type="submit" className="button button-primary" disabled={formLoading}>
                        {formLoading ? <FaSpinner className="spinner" /> : <FaPlus />}
                        ساخت گروه
                    </button>
                </form>
                {formError && <div className="alert alert-danger mt-2">{formError}</div>}
            </div>

            {/* لیست گروه‌های موجود */}
            <div className="data-table-container">
                {renderGroupList()}
            </div>
        </div>
    );
};

export default GroupManagementPage;